export function normalizeAudioClass(value) {
  return String(value ?? "")
    .trim()
    .replace(/[\s_]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function normalizeAudioClasses(value) {
  const rawClasses = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(",")
      : value == null
        ? []
        : [value];
  const classes = [];
  const duplicates = [];
  const seen = new Map();

  rawClasses.forEach((rawClass) => {
    const normalized = normalizeAudioClass(rawClass);
    if (!normalized) return;
    const comparisonKey = normalized.toLowerCase();
    if (seen.has(comparisonKey)) {
      const duplicate = seen.get(comparisonKey);
      if (!duplicates.includes(duplicate)) duplicates.push(duplicate);
      return;
    }
    seen.set(comparisonKey, normalized);
    classes.push(normalized);
  });

  return { classes, duplicates };
}

export function formatTrainingError(data, fallback) {
  if (!data || typeof data !== "object") return String(data || fallback);
  const header = [data.error_code, data.failed_stage].filter(Boolean).join(" / ");
  const cause = data.root_cause || data.error || fallback;
  return header ? `[${header}] ${cause}` : String(cause);
}

export function normalizeDetectionClasses(value) {
  const entries = Array.isArray(value) ? value : typeof value === "string" ? value.split(",") : [];
  const classes = [];
  const seen = new Set();
  for (const entry of entries) {
    if (typeof entry !== "string" || !entry.trim() || /[,\r\n]/.test(entry)) {
      throw new Error("Each class must be a non-empty name without commas or newlines.");
    }
    const name = entry.trim();
    const key = name.toLowerCase();
    if (seen.has(key)) throw new Error(`Duplicate class: ${name}`);
    seen.add(key);
    classes.push(name);
  }
  if (!classes.length) throw new Error("FaceDetection requires at least one class.");
  return classes;
}
